import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
} from "@mui/material";
import TAGlogo from "assets/images/TAGlogo.svg";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import ResetPasswordForm from "components/Forms/ResetPasswordForm";
import ResetPasswordSuccessCard from "components/Card/ResetPasswordSuccessCard";
import LoadingModal from "components/ModalComponent/LoadingModal";

const Alert = React.forwardRef(function Alert(props, ref) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
function CreatePassword() {
  const [showCard, setShowCard] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [loading, setLoadingBar] = useState(false);
  const [verificationToken, setVerificationToken] = useState("");

  const responseHandler = (response) => {
    setLoadingBar(false);
    if (response.status) {
      setOpenAlert(true);
      setShowCard(true);
    } else {
      setOpenAlert(response);
    }
  };

  const getVerificationToken = () => {
    const url = new URL(window.location.href);
    const paramID = url.searchParams.get("token");
    setVerificationToken(paramID);
  };

  useEffect(() => {
    getVerificationToken();
  }, []);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
    setShowAlert(false);
  };
  return (
    <div>
      <Snackbar open={showAlert} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
          Password changed successfully!
        </Alert>
      </Snackbar>
      <Snackbar
        open={openAlert}
        autoHideDuration={6000}
        onClose={handleClose}

        // action={action}
      >
        <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
          Email or password is wrong!
        </Alert>
      </Snackbar>
      <Box
        sx={{
          borderBottom: "2px solid #CACACA",
          typography: "body1",
          paddingBottom: "1%",
        }}
        className="box-style"
      >
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <img className="login-logo" src={TAGlogo} alt="Error in loading" />
          </Grid>
        </Grid>
      </Box>
      <Divider />
      <div className="container">
        <Grid
          container
          spacing={2}
          direction="column"
          alignItems="center"
          justify="center"
          className="form-alignment"
        >
          <Grid item xs={12}>
            <Grid item xs={12}>
              {showCard ? (
                <Card>
                  <CardContent className="login-form-content">
                    <Typography className="login-card-header">
                      <div className="default-card-header-padding">
                        <h2 className="default-card-header-text">
                          Create a new password
                        </h2>
                      </div>
                    </Typography>
                    <div
                      className="default-card-body-padding"
                      id="underlinehide"
                    >
                      <ResetPasswordForm
                        responseFunc={responseHandler}
                        loadingStatusFunc={setLoadingBar}
                        verificationToken={verificationToken}
                      />
                    </div>
                  </CardContent>
                </Card>
              ) : (
                <ResetPasswordSuccessCard />
              )}
            </Grid>
          </Grid>
        </Grid>
      </div>
      <LoadingModal openLoadingModal={loading} body="Loading" />
    </div>
  );
}
export default CreatePassword;
